


import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Add this import
import App from './App';

// Console output is kept in production so wallet/balance failures can be
// diagnosed from a user's device — they are silent and unreproducible
// otherwise. Set REACT_APP_SILENCE_LOGS=true at build time to suppress it.
// console.error is never suppressed.
if (
  process.env.NODE_ENV === "production" &&
  process.env.REACT_APP_SILENCE_LOGS === "true"
) {
  console.log = () => {};
  console.warn = () => {};
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

